import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventModel, EventScoreboard, SetGameScore, TennisScore } from '@frontend/sports/betting-offer/feature/model';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { TwoDigitConverterPipe } from '../common/two-digit-converter.pipe';

@Component({
    selector: 'ms-set-game-scoreboard',
    templateUrl: 'set-game-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, TwoDigitConverterPipe, IconCustomComponent],
})
export class SetGameScoreboardComponent {
    @Input() event: EventModel;
    @Input() showSportIcon = false;

    get vm(): EventScoreboard {
        return this.event.scoreboard;
    }

    get setsCount(): number {
        if (this.vm.score instanceof TennisScore || this.vm.score instanceof SetGameScore) {
            return this.vm.score.setCount || 0;
        }

        return 0;
    }

    get setsArray(): Array<number> {
        const count = this.setsCount;
        if (count > 0) {
            return Array.from(new Array(count)).map((x, i) => i);
        }

        return new Array();
    }

    get score(): SetGameScore {
        return this.vm.score as SetGameScore;
    }

    get turn(): number | null {
        return this.score ? this.score.currentlyServing : null;
    }

    get isTennis(): boolean {
        return this.vm.score instanceof TennisScore;
    }

    get useTwoDigitFormat(): boolean {
        return this.showSportIcon;
    }

    isHighlighedSet(setIndex: number, player: number): boolean {
        if (setIndex < 0 || setIndex >= this.setsCount) {
            return false;
        }
        if (
            this.score.participant1.sets &&
            this.score.participant1.sets.length > 0 &&
            this.score.participant2.sets &&
            this.score.participant2.sets.length > 0
        ) {
            const isFinished = this.isSetFinished(setIndex);
            if (!isFinished) {
                return true;
            }

            return (
                (player === 1 && this.score.participant1.sets[setIndex].points > this.score.participant2.sets[setIndex].points) ||
                (player === 2 && this.score.participant1.sets[setIndex].points < this.score.participant2.sets[setIndex].points) ||
                (this.score.participant1.sets[setIndex].points === this.score.participant2.sets[setIndex].points &&
                    +this.score.participant1.sets[setIndex].points > -1)
            );
        }

        return false;
    }

    getSetScore(setIndex: number, player: number): string {
        if (
            this.score.participant1.sets &&
            this.score.participant1.sets.length > 0 &&
            this.score.participant2.sets &&
            this.score.participant2.sets.length > 0
        ) {
            if (player === 1) {
                return this.score.participant1.sets[setIndex].points.toString();
            } else {
                return this.score.participant2.sets[setIndex].points.toString();
            }
        }

        return '-';
    }

    private isSetFinished(setIndex: number): boolean {
        if (setIndex === this.setsCount - 1) {
            return !this.score.participant1.sets[setIndex].current || !!this.vm.isFinished;
        }

        return !this.score.participant1.sets[setIndex].current;
    }
}
